import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import SectionCard from './SubSection.js'
import {storePayload} from '../actions/storePayload.js'
// import Footer from './Footer'
import '../styles/SectionSelectPage.css'
import FormFooter from './FormFooter.js'
import ChatSection from './ChatSection.js'

function SectionSelectPage(props) {
  const [sections, setSections] = useState()
  useEffect(() => {
    if (props.prompt1Response) {
      setSections(Object.keys(props.prompt1Response))
    }
  }, [props.prompt1Response])

  function onClickSection(sectionIndex, name) {
    const selectedSubSectionName =
      Object.keys(props.prompt1Response[name])[props.selectedSubSectionIndex]
    props.storePayload({
      selectedSectionIndex: sectionIndex,
      selectedSectionName: name,
      selectedSubSectionIndex: 0,
      selectedSubSectionName: selectedSubSectionName,
      isSubSectionReadyForReview: false,
      isSectionReadyForReview: false,
      isReview: false,
      isSkip: false,
      isResourcesPage: false,
      typeFormStep: 'typeform',
    })
  }

  function onClickStart() {
    console.log('To do: on click start')
    props.storePayload({
      typeFormStep: 'typeform',
      step: 'type-form',
    })
  }

  function onClickChat() {
    console.log('setting is chat showing', !props.isChatShowing)
    props.storePayload({
      isChatShowing: !props.isChatShowing,
    })
  }

  return (
    <div id='section-select-page'>
      <ChatSection isChatShowing={props.isChatShowing} />
      <div
        id='section-select-content'
      >
        <header>
          <h2>
            {`${props.selectedPath} Pathway`}
          </h2>
        </header>
        <main
          onClick={() => props.storePayload({isChatShowing: false})}
        >
          {sections && sections.map((section, i) => {
            const sectionData = props.prompt1Response[sections[i]]
            const total = Object.keys(sectionData).length
            let completed = 0
            Object.keys(sectionData).forEach((subSectionName, j) => {
              const subSection = sectionData[subSectionName]
              // const isSubSectionComplete =
              //   Object.keys(subSection).every((id) => {
              //     const question = subSection[id]
              //     return question['Answer']
              //   })
              const isSubSectionComplete =
                subSection['Response'] ? true : false
              if (isSubSectionComplete) {
                completed++
              }
            })
            const status = completed === total ? 'Complete' : 'Incomplete'
            return (
              <div
                key={`${section} ${i}`}
                className={'section-card'}
              >
                <SectionCard
                  number={i + 1}
                  title={sections[i]}
                  completed={completed}
                  total={total}
                  status={status}
                  key={'section-' + i}
                  index={i}
                  isSelected={props.selectedSectionName === sections[i]}
                  onClick={() => onClickSection(i, sections[i])}
                />
              </div>
            )
          })}
        </main>
        <FormFooter
          btn1Text={'Start'}
          onClickBtn1={props.selectedSectionName ? onClickStart : null}
          onClickArrowUp={null}
          onClickArrowDown={null}
          onClickChat={onClickChat}
          theme={props.theme}
          onClick={() => props.storePayload({isChatShowing: false})}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  prompt1Response: state.userReducer.prompt1Response,
  isLoading: state.userReducer.isLoading,
  selectedPath: state.userReducer.selectedPath,
  theme: state.userReducer.theme,
  step: state.userReducer.step,
  selectedSectionName: state.userReducer.selectedSectionName,
  isChatShowing: state.userReducer.isChatShowing,
  isLocalStorageModal: state.userReducer.isLocalStorageModal,
  isLocalStorageModalShowing: state.userReducer.isLocalStorageModalShowing,
  dataSavedAt: state.userReducer.dataSavedAt,
  dataInProgress: state.userReducer.dataInProgress,
  localDataInProgress: state.userReducer.localDataInProgress,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(SectionSelectPage)
